import Cookies from 'universal-cookie';
// import config from '../../config.json';
// const env = process.env.REACT_APP_ENVIRONMENT || 'stage';
// const BACKEND_URL = config.api[env];

// import axios from 'axios';

const moment = require('moment');

export function login(email, pass, cb) {
  cb = arguments[arguments.length - 1];
  if (localStorage.jwtToken) {
    if (cb) {
      cb(true);
    }
    return;
  }

  throw new Error('Login indisponível, tente logar pela nova versão');
}

export function getToken() {
  return localStorage.jwtToken;
}

export function logout(cb) {
  delete localStorage.jwtToken;
  delete localStorage.expiration;
  delete localStorage.permissions;
  if (cb) cb();
}

export function loggedIn() {
  const cookies = new Cookies();

  const jwtToken = cookies.get('auth_bo_token');
  const expiration = cookies.get('auth_bo_expiration');
  const user = cookies.get('auth_bo_user');

  if (!jwtToken || !expiration || !localStorage?.permissions) {
    return false;
  }

  localStorage.jwtToken = jwtToken;
  localStorage.expiration = expiration;
  localStorage.user = JSON.stringify(user);

  const loggeId = jwtToken && moment(expiration) > moment();
  return loggeId;
}

export function userIsAdmin() {
  const user = localStorage.getItem('user');
  return user && user.type === 'administrator';
}

export function userIsMarketingHead() {
  const user = localStorage.getItem('user');
  return user && user.type === 'marketingHead';
}

export function userIsMaster() {
  const user = localStorage.getItem('user');
  return user && user.type === 'master';
}

export function userIsHead() {
  
  const user = JSON.parse(localStorage.getItem('user'));
  return (
    user &&
    (user.type === 'financeHead' ||
      user.type === 'operationHead' ||
      user.type === 'marketingHead' ||
      user.type === 'master')
  );
}

export default { login, getToken, logout, loggedIn };

